import React, { FC } from 'react'

import { IconNumber7Props } from './IconNumber7.types'
import * as Styled from './styles/IconNumber7.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNumber7: FC<IconNumber7Props> = ({
  size = nonThemeableRules.defaultSize as number as IconNumber7Props['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconNumber7Props) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M80 0a80 80 0 1 0 80 80A80.09 80.09 0 0 0 80 0zm0 152a72 72 0 1 1 72-72 72.08 72.08 0 0 1-72 72z' />
        <path d='M103.5 40H60a4 4 0 0 0 0 8h35.81l-.37.52a150.22 150.22 0 0 0-25.53 64.34l-.37 2.57a4 4 0 1 0 7.92 1.14l.37-2.57A142.18 142.18 0 0 1 102 53.12l4.78-6.82a4 4 0 0 0-3.28-6.3z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNumber7
